import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3d917110"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "copycard-dropdown-content d-flex flex-column gap-2" }
const _hoisted_2 = { class: "copycard-dropdown-content__textarea" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "label mb-1" }, "Title", -1))
const _hoisted_4 = {
  key: 0,
  class: "copycard-dropdown-content__textarea__keep"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "label mb-1" }, "Keep...", -1))
const _hoisted_6 = { class: "p-0 m-0" }
const _hoisted_7 = {
  key: 0,
  class: "d-flex gap-2"
}
const _hoisted_8 = {
  key: 1,
  class: "d-flex gap-2"
}
const _hoisted_9 = {
  key: 2,
  class: "d-flex gap-2"
}
const _hoisted_10 = {
  key: 3,
  class: "d-flex gap-2"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_task_card_action_form = _resolveComponent("task-card-action-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _withDirectives(_createElementVNode("textarea", {
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.keep.task) = $event)),
        cols: "30",
        class: "form-control mb-2",
        autofocus: ""
      }, null, 512), [
        [_vModelText, _ctx.keep.task]
      ]),
      (_ctx.showKeeps)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _hoisted_5,
            _createElementVNode("ul", _hoisted_6, [
              (_ctx.keeps.attachments)
                ? (_openBlock(), _createElementBlock("li", _hoisted_7, [
                    _withDirectives(_createElementVNode("input", {
                      class: "form-check-input",
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.keep.attachments) = $event)),
                      type: "checkbox"
                    }, null, 512), [
                      [_vModelCheckbox, _ctx.keep.attachments]
                    ]),
                    _createTextVNode(" Attachments (" + _toDisplayString(_ctx.keeps.attachments) + ") ", 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.keeps.comments)
                ? (_openBlock(), _createElementBlock("li", _hoisted_8, [
                    _withDirectives(_createElementVNode("input", {
                      class: "form-check-input",
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.keep.comments) = $event)),
                      type: "checkbox"
                    }, null, 512), [
                      [_vModelCheckbox, _ctx.keep.comments]
                    ]),
                    _createTextVNode(" Comments (" + _toDisplayString(_ctx.keeps.comments) + ") ", 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.keeps.members)
                ? (_openBlock(), _createElementBlock("li", _hoisted_9, [
                    _withDirectives(_createElementVNode("input", {
                      class: "form-check-input",
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.keep.members) = $event)),
                      type: "checkbox"
                    }, null, 512), [
                      [_vModelCheckbox, _ctx.keep.members]
                    ]),
                    _createTextVNode(" Members (" + _toDisplayString(_ctx.keeps.members) + ") ", 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.keeps.labels)
                ? (_openBlock(), _createElementBlock("li", _hoisted_10, [
                    _withDirectives(_createElementVNode("input", {
                      class: "form-check-input",
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.keep.labels) = $event)),
                      type: "checkbox"
                    }, null, 512), [
                      [_vModelCheckbox, _ctx.keep.labels]
                    ]),
                    _createTextVNode(" Labels (" + _toDisplayString(_ctx.keeps.labels) + ") ", 1)
                  ]))
                : _createCommentVNode("", true)
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_task_card_action_form, {
      title: "Copy to...",
      "submit-text": "Create card",
      disable: _ctx.keep.task.length < 1,
      onSubmit: _ctx.handleCopySubmit
    }, null, 8, ["disable", "onSubmit"])
  ]))
}